import { AlertTriangle, ExternalLink } from "lucide-react";

/**
 * PlausiWarnings — rendert UVA-Plausi-Hinweise.
 * - `warningItems`: strukturierte Hinweise mit optionalem Deeplink zur Quelle
 *   (z.B. Rechnung ohne USt-Satz). `onOpenItem(item)` öffnet die Quelle.
 * - `warnings`: einfache Text-Hinweise (ohne Verlinkung).
 */
export function PlausiWarnings({ warnings = [], warningItems = [], onOpenItem, testId = "plausi-warnings" }) {
  const total = (warnings?.length || 0) + (warningItems?.length || 0);
  if (total === 0) return null;
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3" data-testid={testId}>
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
        <div className="text-xs text-amber-900 w-full">
          <div className="font-medium uppercase tracking-wide text-amber-700 mb-1.5">
            {total} Plausi-Hinweis{total !== 1 ? "e" : ""}
          </div>
          <div className="space-y-1">
            {(warningItems || []).map((w, i) => (
              <div key={`wi-${i}`} className="flex items-start justify-between gap-2"
                data-testid={`plausi-warning-item-${i}`}>
                <span className="min-w-0">• {w.message}</span>
                {w.entity_id && onOpenItem && (
                  <button onClick={() => onOpenItem(w)}
                    className="shrink-0 inline-flex items-center gap-1 text-amber-800 hover:text-amber-950 underline font-medium"
                    data-testid={`plausi-warning-open-${i}`}
                    title="Zur Quelle springen (neuer Tab)">
                    <ExternalLink className="w-3 h-3" />{w.entity_label || "Öffnen"}
                  </button>
                )}
              </div>
            ))}
            {(warnings || []).map((w, i) => <div key={`w-${i}`}>• {w}</div>)}
          </div>
        </div>
      </div>
    </div>
  );
}
